/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
const status = {
  pending: "#ff6d00",
  complete: "#64dd17",
  info: "#03a9f4",
  appointed: "#304ffe",
  delivered: "#00c853",
  reopen: "",
  recontact: "#78909c",
  requested: "#ffb300",
  failToDelivery: "#ff3d00",
  outForDelivery: "#00bcd4",
  return: "#7f0000",
  default: "#62757f",
  primary: '#78be20',
  invalid: '#fc0703'
}

const app = {
  primary: "#ff6d00",
  secondary: "#90caf9",
  pink : "#d81b60",
}

const colors = {
  status,
  app,
}

export {
  colors,
}
